"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapChannelPricingToVod = exports.mapChannelPricingToGql = exports.mapSettingsPricingToVod = exports.mapSettingsPricingToGql = exports.mapVideoPricingToVod = exports.mapVideoPricingToGql = void 0;
const common_1 = require("@wix/wix-vod-constants/common");
const globalTypes_1 = require("../private/generated/globalTypes");
const enum_mapper_1 = require("../utils/enum-mapper");
const videoPricingTypeMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.VideoPricingType.SALE]: common_1.DEAL_INFO_TYPES.SALE,
    [globalTypes_1.VideoPricingType.RENT]: common_1.DEAL_INFO_TYPES.RENT,
});
const channelPricingTypeMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.ChannelPricingType.SUBSCRIPTION]: common_1.DEAL_INFO_TYPES.SUBSCRIPTION,
    [globalTypes_1.ChannelPricingType.PRICING_PLAN]: common_1.DEAL_INFO_TYPES.PLAN,
});
const settingsPricingTypeMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.SettingsDefaultPricingType.SALE]: common_1.DEAL_INFO_TYPES.SALE,
    [globalTypes_1.SettingsDefaultPricingType.RENT]: common_1.DEAL_INFO_TYPES.RENT,
});
function mapPricingToGql(dealInfo) {
    return {
        price: dealInfo.price,
        enabled: dealInfo.enabled,
        period: dealInfo.period || -1,
    };
}
function mapPricingToVod(pricing) {
    return {
        price: pricing.price,
        enabled: pricing.enabled,
        period: pricing.period,
        currency: pricing.currency,
    };
}
function mapVideoPricingToGql(dealInfo) {
    return Object.assign(Object.assign({}, mapPricingToGql(dealInfo)), { type: videoPricingTypeMapper.toGql(dealInfo.type) });
}
exports.mapVideoPricingToGql = mapVideoPricingToGql;
function mapVideoPricingToVod(pricing) {
    return Object.assign(Object.assign({}, mapPricingToVod(pricing)), { type: videoPricingTypeMapper.toVod(pricing.type) });
}
exports.mapVideoPricingToVod = mapVideoPricingToVod;
function mapSettingsPricingToGql(dealInfo) {
    return Object.assign(Object.assign({}, mapPricingToGql(dealInfo)), { type: settingsPricingTypeMapper.toGql(dealInfo.type) });
}
exports.mapSettingsPricingToGql = mapSettingsPricingToGql;
function mapSettingsPricingToVod(pricing) {
    return Object.assign(Object.assign({}, mapPricingToVod(pricing)), { type: settingsPricingTypeMapper.toVod(pricing.type) });
}
exports.mapSettingsPricingToVod = mapSettingsPricingToVod;
function mapChannelPricingToGql(dealInfo) {
    return Object.assign(Object.assign({}, mapPricingToGql(dealInfo)), { type: channelPricingTypeMapper.toGql(dealInfo.type), required: dealInfo.required || false });
}
exports.mapChannelPricingToGql = mapChannelPricingToGql;
function mapChannelPricingToVod(pricing) {
    return Object.assign(Object.assign({}, mapPricingToVod(pricing)), { type: channelPricingTypeMapper.toVod(pricing.type), required: pricing.required });
}
exports.mapChannelPricingToVod = mapChannelPricingToVod;
//# sourceMappingURL=pricing.js.map